import { useEffect } from 'react';

import NotificationsService from '../services/NotificationsService';

type NotificationTokenListenerType = (token: string) => void;

export function useNotificationsTokenListener(
  listener: NotificationTokenListenerType,
) {
  useEffect(() => {
    NotificationsService.getToken()
      .then((token) => {
        if (token) {
          listener(token);
        }
      })
      .catch(() => {
        // do nothing
      });

    return NotificationsService.onTokenRefresh(listener);
  }, []);
}
